import { Typography } from "@mui/material";
import _ from "lodash";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Scrollbar from "../../../components/Scrollbar/Scrollbar";
import { useStyles } from "../../../pages/NewOrder/styles";
import GroupList from "../../../sections/restaurant/items/GroupList";
import ItemMenu from "../../../sections/restaurant/items/ItemMenu";
import SubGroupList from "../../../sections/restaurant/items/SubGroupList";
import { AppContext } from "../../../AppContext";
import {
    useAddons,
    useItemGroups,
    useItems,
} from "../../../shared/hooks/useItemsData";
import { useTableOrderItems } from "../../../shared/hooks/useTableOrderItemsData";
import { useOrderDetails } from "../../../shared/hooks/useTablesData";
import HelmetMeta from "./../../../components/HelmetMeta";

const Menu = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { menuAllowedGroups } = useContext(AppContext);

    const [selectedOrder, setSelectedOrder] = useState(null);

    const [category, setCategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subCategory, setSubCategory] = useState(null);

    const [addItemOpen, setAddItemOpen] = useState(false);
    const [addedItem, setAddedItem] = useState(null);

    const [editedItem, setEditedItem] = useState(null);
    const [editedOrderItem, setEditedOrderItem] = useState(null);
    const [menuItems1, setMenuItems1] = useState(null);

    const [items, setItems] = useState([]);

    const { data: addonsItems } = useAddons();

    const { data: menuItems } = useItems({ allowedGroups: menuAllowedGroups });
    const { data: groupedItems } = useItemGroups({ allowedGroups: menuAllowedGroups });

    // This is our selected order.
    const { orderId, customer } = useParams();
    const { data: orderItems } = useTableOrderItems(orderId || null);
    const { data: orderDetails } = useOrderDetails(orderId || null);

    useEffect(() => {
        if (orderDetails) {
            setSelectedOrder(orderDetails.data.data);
        }
    }, [orderDetails]);

    /**
     * Pushes item to selected order.
     * @param item
     */
    const onItemClick = (item) => {
        if (!item) {
            return;
        }

        // if (item.projected_qty == 0) {
        //     enqueueSnackbar(
        //         <>
        //             <div className={classes.NotificationSnackbarContent}>
        //                 <div className={classes.NotificationIcon}></div>
        //                 <div className={classes.NotificationLabel}>
        //                     <Typography
        //                         color={"#271D1C"}
        //                         lineHeight={"17px"}
        //                         fontWeight={700}
        //                         fontFamily={"Inter"}
        //                         fontSize={"14px"}
        //                     >
        //                         {item.name.toUpperCase() + " IS OUT OF STOCK"}
        //                     </Typography>
        //                     <Typography
        //                         color={"rgba(13, 13, 17, 0.5)"}
        //                         lineHeight={"15px"}
        //                         fontWeight={500}
        //                         fontFamily={"Inter"}
        //                         fontSize={"12px"}
        //                     >
        //                         {item.name.toUpperCase() + " IS OUT OF STOCK"}
        //                     </Typography>
        //                 </div>
        //             </div>
        //         </>
        //     );
        //     return;
        // }

        setAddedItem(item);
        setAddItemOpen(true);
    };

    const onGroupClicked = (group) => {
        if (group && !group.name) {
            setCategory(null);
            setSelectedCategory(null);
            setSubCategory(null);
            return;
        }

        setCategory(group);

        // const { id, name, cover } = group;
        setSelectedCategory(group);
        setSubCategory(null);
    };

    const onSubGroupClicked = (subGroup) => {
        if (subGroup && !subGroup.name) {
            setSubCategory(null);
            return;
        }
        setSubCategory(subGroup);
    };

    useEffect(() => {
        if (orderItems) {
            const itemCodes = addonsItems.map((item) => item.item_code);
            const filteredItems2 = _.filter(
                Object.values(orderItems.items),
                (item) => !_.includes(itemCodes, item.item_code)
            );
            setItems(filteredItems2);
        } else {
            setItems([]);
        }
    }, [orderItems]);

    const onItemsLoaded = (items) => {
        setMenuItems1(items);
    };

    useEffect(() => {
        if (editedOrderItem) {
            let itemInOrder;
            if (menuItems1 && menuItems1.length > 0)
                itemInOrder = _.find(menuItems1, {
                    item_code: editedOrderItem.item_code,
                });

            if (itemInOrder) {
                setEditedItem(itemInOrder);
            }
        } else {
            setEditedItem(null);
        }
    }, [editedOrderItem]);

    return (
        <>
            <div className={classes.NotificationSnackbarIcon}></div>

            <div className={classes.PageWrap}>
                <HelmetMeta title={"New Order"} />
                <div className={classes.NewOrderPage}>
                    <div className={classes.Categories}>
                        <div className={"CategoriesTitle"}>main categories</div>
                        <div className={"CategoriesList"}>
                            <GroupList onClick={onGroupClicked}></GroupList>
                        </div>
                    </div>
                    <div className={classes.CategoryView}>
                        <div className={"CategoryView__Header"}>
                            <div className={"Header__Title"}>
                                <div onClick={onSubGroupClicked}>
                                    {selectedCategory
                                        ? selectedCategory.name
                                        : ""}
                                </div>
                                <div onClick={onSubGroupClicked}>
                                    SubCategories
                                </div>
                            </div>
                            <div className={"Subcatgories"}>
                                <SubGroupList
                                    parentItem={selectedCategory}
                                    onClick={onSubGroupClicked}
                                ></SubGroupList>
                            </div>
                        </div>
                        <Scrollbar>
                            <ItemMenu
                                groupedItems={groupedItems}
                                menuItems={menuItems}
                                onClick={onItemClick}
                                category={category}
                                subCategory={subCategory}
                                onItemsLoaded={onItemsLoaded}
                            ></ItemMenu>
                        </Scrollbar>
                    </div>
                </div>
            </div>
            <SnackbarProvider className={classes.NotificationSnackbar} />
        </>
    );
};

export default Menu;
